<template>
    <div style="display: contents;">
        <template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
                        :fab="button.params.fab ? button.params.fab : false"
                        :icon="button.params.fab ? false : true"
                        :small="button.params.small ? true : false"
                        :fixed="button.params.fixed ? true : false"
                        :absolute="button.params.absolute ? true : false"
                        :bottom="button.params.bottom ? true : false"
                        :right="button.params.right ? true : false"
                        :dark="button.params.dark ? true : false"
                        :color="button.params.button_color ? button.params.button_color : ''"
                        @click="openDialog">
                        <v-icon :color="button.params.color ? button.params.color : ''">{{ button.params.icon ? button.params.icon : 'mdi-briefcase-plus-outline' }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ button.params.tooltip ? button.params.tooltip : 'Crea Opportunità' }}</span>
            </v-tooltip>
        </template>

        <v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense 
            :disabled="disabled"
            @click.stop="openDialog()"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ button.params.icon ? button.params.icon : 'mdi-briefcase-plus-outline' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ button.params.tooltip ? button.params.tooltip : 'Crea Opportunità' }}</v-list-item-title>
            </v-list-item-content>

        </v-list-item>

        <v-dialog v-model="open" max-width="900" persistent>
            <v-card class="round-card background-1">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Crea Opportunità</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4 body-2">
                    Vuoi generare le opportunità per i destinatari più attivi della campagna?
                    
                    <span v-if="linkId"><br>Solo per coloro che hanno cliccato sul link specifico.</span>
                </v-card-text>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                    <fields-generator
                        v-if="loaded"
                        :fieldsset.sync="fieldsset"
                        :model.sync="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="info"
                        @click.native="open = false">
                        Annulla
                    </v-btn>
                    <v-btn 
                        text
                        color="primary"
                        @click.native="generateOpportunities()"
                        :loading="loading">
                        Procedi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import FormsMixin from '@/mixins/FormsMixin'

export default {
	name: 'opportunity-campaign-dialog',
    mixins: [FormsMixin],
	props: {
		button: Object,
        buttonComponent: {type: String, default : 'v-btn'},
		params: Object,
        campaignId: {
            type: Number,
            required: true
        },
        linkId: {
            type: String,
            required: false,
            default: null
        },
	},
	data() {
		return {
			model: {'campaign_id': this.campaignId},
			loading: false,
            fieldsset: [],
			loaded: false,
			firstTime: true,
            open: false,
		}
	},

	watch: {
		open: {
			handler() {
				if(this.open == true && this.firstTime == true) {
					this.axios.get('/opportunities-campaigns/create').then(response => {
						// get body data
						this.fieldsset = response.data.fields
						this.loaded = true
						this.firstTime = false

						_.forEach(this.fieldsset.fields, (value, key) => {
							if(value.type === 'checkbox') {
								this.$set(this.model, value.key, '')
							}
							if(value.default) {
								this.$set(this.model, value.key, value.default)
							}
						})
					}, response => {
						// error callback
						this.loading = false
					})
				}
			}
		}
	},

	methods: {
        openDialog() {
            this.open = true
        },

		generateOpportunities() {
			this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
				if (!result) {
					return this.handleValidationErrorAdvanced()
				}			
                
                if (this.linkId) {
                    this.$set(this.model, 'link_id', this.linkId)
                }

				this.loading = true

				this.axios.post('opportunities-campaigns/', this.model).then(response => {
					// get body data
					let data = response.data
					let snackmessage = ''
					let snackcolor = ''
                    if(data.status == 'message' || data.message) {
						snackmessage = data.message
					} else{
						snackmessage = 'Generazione Opportunità avviata'
					}					
                    snackcolor = data.status
					this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

					this.loading = false
					this.open = false
				}, response => {
					// error callback
					this.loading = false
				})
			}).catch(() => {

			})				
		},
	},
}
</script>

